/*
 * @Descripttion:
 * @Author: sjq
 * @Date: 2021-07-01 19:56:03
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-01 15:03:18
 */
import { request } from '@/utils/request'
import { getPublicKey } from '@/api/login'
import { encryptLoginPassword, generateResetPassword } from '@/utils/loginCrypto'

//员工列表
export function getStaffList(params) {
  return request({
    url: '/sgsf-platform/employee/page',
    method: 'get',
    params
  })
}

// 7.2. 获取员工授权信息
export function getStaffDetail(params) {
  return request({
    url: `/sgsf-platform/employee/${params.userId}`,
    method: 'get',
    params
  })
}
// 7.4. 获取部门
export function getDepartmentList(params) {
  return request({
    url: `/sgsf-platform/employee/departments`,
    method: 'get',
    params
  })
}
// 7.3. 授予用户权限
export function setStaffRole(data, userId) {
  return request({
    url: `/sgsf-platform/employee/${userId}/grant-user-permission`,
    method: 'post',
    data
  })
}

// 重置密码
export async function resetPassword(data) {
  const newPassword = generateResetPassword(8)
  console.log(newPassword)
  const publicKey = await getPublicKey()
  const newPayload = encryptLoginPassword(newPassword, publicKey)
  const res = await request({
    url: '/sgsf-user-center/auth/password/reset',
    method: 'post',
    data: {
      userId: data.userId,
      newEncryptedPassword: newPayload.encryptedPassword,
      newEncryptedKey: newPayload.encryptedKey,
      newIv: newPayload.iv,
      newTimestamp: newPayload.timestamp,
      newSalt: newPayload.salt
    }
  })
  return { ...res, newPassword }
}
// 修改密码
export async function updatePassword(data, token) {
  const publicKey = await getPublicKey()
  const oldPayload = encryptLoginPassword(data.oldPassword, publicKey)
  const newPayload = encryptLoginPassword(data.newPassword, publicKey)
  return request({
    url: '/sgsf-user-center/auth/password',
    method: 'put',
    headers: {
      authorization: token
    },
    data: {
      encryptedPassword: oldPayload.encryptedPassword,
      encryptedKey: oldPayload.encryptedKey,
      iv: oldPayload.iv,
      timestamp: oldPayload.timestamp,
      salt: oldPayload.salt,
      newEncryptedPassword: newPayload.encryptedPassword,
      newEncryptedKey: newPayload.encryptedKey,
      newIv: newPayload.iv,
      newTimestamp: newPayload.timestamp,
      newSalt: newPayload.salt
    }
  })
}
//
export function jyeooRefresh(data) {
  return request({
    url: `/sgsf-platform/employee/${data.userId}/grant-jyeoo-permission`,
    method: 'post',
    data
  })
}
